import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-30ccb144"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row justify-content-center mt-5" }
const _hoisted_2 = { class: "col-xl-3 col-lg-4 col-md-6 mb-4" }
const _hoisted_3 = { class: "resp-photo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "resp-name" }, "Mgr Roger Houngbédji", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "resp-role" }, "Chancelier", -1))
const _hoisted_6 = { class: "col-xl-3 col-lg-4 col-md-6 mb-4" }
const _hoisted_7 = { class: "resp-photo" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "resp-name" }, "Père Rodrigue Gbédjinou", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "resp-role" }, "Directeur et Responsable Service de la recherche et de l’innovation méthodologique ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "Les formateurs", -1))
const _hoisted_11 = { class: "row justify-content-center mt-5" }
const _hoisted_12 = { class: "col-xl-3 col-lg-4 col-md-6 mb-4" }
const _hoisted_13 = { class: "resp-photo" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "resp-name" }, "Père Rodrigue Gbédjinou ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "resp-role" }, "Formateur", -1))
const _hoisted_16 = { class: "col-xl-3 col-lg-4 col-md-6 mb-4" }
const _hoisted_17 = { class: "resp-card" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "resp-name" }, "Père Narcisse Bah-Kpêvi", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "resp-role" }, "Formateur", -1))
const _hoisted_20 = { class: "col-xl-3 col-lg-4 col-md-6 mb-4" }
const _hoisted_21 = { class: "resp-photo" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "resp-name" }, "Père Romuald Hounsa", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "resp-role" }, "Formateur", -1))
const _hoisted_24 = { class: "modal-content" }
const _hoisted_25 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "resp-card",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('/Chancelier.jpg')))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: "/Chancelier.jpg",
              alt: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal('/Chancelier.jpg')))
            })
          ]),
          _hoisted_4,
          _hoisted_5
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "resp-card",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModal('/2.jpg')))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              src: "/2.jpg",
              alt: "",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal('/2.jpg')))
            })
          ]),
          _hoisted_8,
          _hoisted_9
        ])
      ])
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", {
          class: "resp-card",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openModal('/2.jpg')))
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("img", {
              src: "/2.jpg",
              alt: "",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openModal('/2.jpg')))
            })
          ]),
          _hoisted_14,
          _hoisted_15
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", {
            class: "resp-photo",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openModal('/Père Narcisse BAH-KPEVI.jpeg')))
          }, [
            _createElementVNode("img", {
              src: "/Père Narcisse BAH-KPEVI.jpeg",
              alt: "",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openModal('/Père Narcisse BAH-KPEVI.jpeg')))
            })
          ]),
          _hoisted_18,
          _hoisted_19
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", {
          class: "resp-card",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openModal('/Père Romuald HOUNSA.JPG')))
        }, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("img", {
              src: "/Père Romuald HOUNSA.JPG",
              alt: "",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openModal('/Père Romuald HOUNSA.JPG')))
            })
          ]),
          _hoisted_22,
          _hoisted_23
        ])
      ])
    ]),
    (_ctx.isModalOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "image-modal",
          onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("span", {
              class: "close-btn",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, "×"),
            _createElementVNode("img", {
              src: _ctx.selectedImage,
              class: "modal-image"
            }, null, 8, _hoisted_25)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}